// LIFF abstraction: the real @line/liff SDK in production, a fake for local development and tests.
import liffSdk from '@line/liff';

export interface LiffLike {
  init(liffId: string): Promise<void>;
  isLoggedIn(): boolean;
  /** Starts login (external browsers only; inside LINE, init logs in automatically). */
  login(redirectUri?: string): void;
  /** Gets a fresh ID token after it expired: reload inside LINE, logout+login elsewhere. */
  relogin(redirectUri: string): void;
  getIDToken(): string | null;
  getDecodedIDToken(): { sub?: string; name?: string; picture?: string } | null;
  isInClient(): boolean;
  openWindow(p: { url: string; external: boolean }): void;
  closeWindow(): void;
}

export function realLiff(): LiffLike {
  return {
    init: (liffId) => liffSdk.init({ liffId }),
    isLoggedIn: () => liffSdk.isLoggedIn(),
    login: (redirectUri) => liffSdk.login(redirectUri ? { redirectUri } : undefined),
    relogin: (redirectUri) => {
      if (liffSdk.isInClient()) {
        window.location.reload();
      } else {
        liffSdk.logout();
        liffSdk.login({ redirectUri });
      }
    },
    getIDToken: () => liffSdk.getIDToken(),
    getDecodedIDToken: () => liffSdk.getDecodedIDToken() ?? null,
    isInClient: () => liffSdk.isInClient(),
    openWindow: (p) => liffSdk.openWindow(p),
    closeWindow: () => liffSdk.closeWindow(),
  };
}

const FAKE_KEY = 'sf_fake_user';

/** Dev user from ?as=U-xxx (remembered for the tab), default "U-dev-customer". */
export function currentFakeUser(): string {
  const fromQuery = new URLSearchParams(window.location.search).get('as');
  if (fromQuery) sessionStorage.setItem(FAKE_KEY, fromQuery);
  return sessionStorage.getItem(FAKE_KEY) ?? 'U-dev-customer';
}

/** Fake LIFF for local development: tokens are "<loginChannelId>:<userId>" (accepted by the dev API). */
export function fakeLiff(loginChannelId: string, userId: string): LiffLike {
  return {
    init: async () => {},
    isLoggedIn: () => true,
    login: () => {},
    relogin: () => window.location.reload(),
    getIDToken: () => `${loginChannelId}:${userId}`,
    getDecodedIDToken: () => ({ sub: userId, name: `ผู้ใช้ ${userId.replace(/^U-/, '')}` }),
    isInClient: () => false,
    openWindow: ({ url }) => { window.open(url, '_blank', 'noopener'); },
    closeWindow: () => {},
  };
}
